import { ReactNode } from 'react';
import { styled } from './styles';

interface ITitle {
  title: string;
  text?: string | ReactNode;
  className?: string;
  textWidth?: number;
  textClassName?: string;
  id?: string;
}

const StyledTitle = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
  position: 'relative',
  h2: {
    fontSize: '58px',
    fontWeight: 600,
    lineHeight: '130%',
    color: 'white',
    textAlign: 'center',
    maxWidth: '877px',
    '@toXL': {
      fontSize: '44px',
      maxWidth: '660px'
    },
    '@toDesktop': {
      fontSize: '38px'
    }
  },
  p: {
    textAlign: 'center',
    fontSize: '24px',
    lineHeight: '27px',
    color: '#d6d2ea',
    '@toXL': {
      fontSize: '18px'
    }
  }
});

const TitleId = styled('span', {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'transparent',
  opacity: 0,
  pointerEvents: 'none',
  width: '5px',
  height: '5px',
  top: '10px',
  '@fromH820': {
    top: '-25px'
  }
});

export const Title = ({ title, text, className, textClassName, id }: ITitle) => {
  return (
    <StyledTitle style={{ gap: text ? 24 : 0 }} className={className}>
      <TitleId id={id}></TitleId>
      <h2>{title}</h2>
      <p className={textClassName}>{text}</p>
    </StyledTitle>
  );
};
